<app-job-pointe-list
  [tableData]="data"
  [tableFilters]="filters"
  [source]="data.type"
  [refreshList]="refreshEmployees"></app-job-pointe-list>

<app-job-pointe-transfer [refreshEmployeesSource]="refreshEmployeesSource"></app-job-pointe-transfer>
